var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{
          name:
            _vm.$route.path.indexOf('bank') !== -1 ? 'bank-deposit' : 'Deposit',
        }}},[_c('span',{staticClass:"tab-text"},[_vm._v(_vm._s(_vm.$t('wallet_page.deposit_list')))])])],1),_c('li',[_c('router-link',{attrs:{"to":{
          name:
            _vm.$route.path.indexOf('bank') !== -1 ? 'bank-withdraw' : 'Withdraw',
        }}},[_c('span',{staticClass:"tab-text"},[_vm._v(_vm._s(_vm.$t('wallet_page.withdraw_list')))])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }